// @flow
import { RangosActionTypes } from './constants';

type RangosAction = { type: string, payload: {} | string };

// common success
export const rangosApiResponseSuccess = (actionType: string, data: any): RangosAction => ({
    type: RangosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const rangosApiResponseError = (actionType: string, error: string): RangosAction => ({
    type: RangosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getRango = (id: string): RangosAction => ({
    type: RangosActionTypes.GET_RANGO,
    payload: { id },
});

export const addRango = (rango:any):RangosAction=>({
    type:RangosActionTypes.ADD_RANGO,
    payload:rango
})
export const updateRango = (rango:any):RangosAction=>({
    type:RangosActionTypes.UPDATE_RANGO,
    payload:rango
})

export const updateRangos = (rangos:any):RangosAction=>({
    type:RangosActionTypes.UPDATE_RANGOS,
    payload:rangos
})
export const deleteRango = (id:string):RangosAction=>({
    type:RangosActionTypes.DELETE_RANGO,
    payload:{id}
})

export const listRangos = (params:any): RangosAction => ({
    type: RangosActionTypes.LIST_RANGOS,
    payload: params,
});

export const resetRangos = (): RangosAction => ({
    type: RangosActionTypes.RESET,
    payload: {},
});

export const resetSoftRangos = (): RangosAction => ({
    type: RangosActionTypes.RESET_SOFT,
    payload: {},
});
